<template>
  <div class="product-summary">
    <div v-if="false && showSummary && $utils.isCartOfflineShippable() && $utils.isCartShippable()">
      <div class="form__item--inline">
        <div class="form__item--inline">
          <label class="form__label">
            <input class="form__input" type="checkbox"
                   :checked="!$utils.isOfflineShipping()"
                   v-on:change="$utils.setOfflineShipping(!$event.target.checked)" />
            <b>ต้องการให้จัดส่ง</b>
          </label>
        </div>
        <div class="form__item--inline">
          <label class="form__label">
            <input class="form__input" type="checkbox"
                   :checked="$utils.isOfflineShipping()"
                   v-on:change="$utils.setOfflineShipping($event.target.checked)" />
            <b>ต้องการรับของเอง</b>
          </label>
        </div>
      </div>
      <hr>
    </div>

    <br>

    <div v-if="!$utils.isCartEmpty()" class="product-cart">
      <div class="product-list product-cart__item" v-for="item in cart">
        <product-list-item :key="sku(item)"
                           :product="item.product"
                           :initialChoices="item.attributes"
                           :initialQuantity="item.quantity"
                           :cart-mode="true"
                           :show-attributes="false"
                           v-on:itemRemoved="itemRemoved"
                           v-on:quantityChanged="updateQuantity"></product-list-item>
      </div>

      <div class="summary" v-if="showSummary">
        <div class="summary__row">
          <div class="summary__label">จำนวนรายการ ({{ $utils.getCartItemCount() }})</div>
          <div class="summary__value">{{ $utils.getCartTotalPrice() | comma }} ฿</div>
        </div>
        <div class="summary__row" v-for="(fee, group) in reducedShippingGroup" v-if="!$utils.isOfflineShipping()">
          <div class="summary__label">{{ group }}</div>
          <div class="summary__value">{{ fee }}  ฿</div>
        </div>
        <hr>
        <div class="summary__row">
          <div class="summary__label">ค่าจัดส่งทั้งหมด</div>
          <div class="summary__value">{{ $utils.getCartShippingFee() | comma }} ฿</div>
        </div>
        <div class="summary__row summary__row--total">
          <div class="summary__label">รวม</div>
          <div class="summary__value">{{ $utils.getCartGrandTotalPrice() | comma }} ฿</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductListItem from '../components/ProductListItem'

export default {
  name: 'CartSummary',
  components: {
    ProductListItem
  },
  props: {
    showSummary: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    reducedShippingGroup () {
      let reduced = {}
      for (let group of Object.keys(this.$utils.getCartShippingGroups())) {
        let groupName = this.$utils.getShippingGroupName(group)
        reduced[groupName] = reduced[groupName] || 0
        reduced[groupName] += this.$utils.getShippingGroupFee(group)
      }
      return reduced
    }
  },
  methods: {
    sku (item) {
      return this.$utils.getProductConfigSku(item.product, item.attributes)
    },
    itemRemoved (product, attributes, quantity) {
      this.$emit('itemRemoved', product, attributes, quantity)
    },
    updateQuantity (product, attributes, quantity) {
      this.$store.dispatch('updateProductQuantity', {
        product: product,
        attributes: attributes,
        quantity: quantity
      })
    }
  }
}
</script>

<style scoped>
  .product-cart__item:last-child {
     border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// CartSummary.vue?2e6fad06